// extracted by mini-css-extract-plugin
export default {"referral-widget":"kr","referral-page":"lr","label":"mr","subHed":"nr","profile-container":"or","referral-container":"pr","referral-header":"qr","shareMethodRow":"rr","shareMethod":"sr","active":"tr","referral-stat":"ur","blockwrapper":"vr","referralLink":"wr","bold":"xr","semibold":"yr","shareAgainButton":"zr","policy":"Ar","narrowWrapper":"Br"};
    if(module.hot) {
      // 1737143653988
      var cssReload = require("../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  